import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import ApplicationTrackingTimeline from "../components/dashboard/ApplicationTrackingTimeline";

const ApplicationTracking: React.FC = () => {
  const { applicationId } = useParams<{ applicationId: string }>();
  const navigate = useNavigate();

  return (
    <div style={{ background: "#f8f9fa", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 border-0">
            <ApplicationTrackingTimeline 
              applicationId={0} 
              applicationCode={applicationId} 
              onBack={() => navigate(-1)} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationTracking;
